import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, description, align = "left" }) => (
  <Reveal className={align === "center" ? "text-center mx-auto max-w-3xl" : "max-w-3xl"}>
    <p className="font-mono-num text-xs uppercase tracking-[0.3em] text-amber-400/90 mb-5" data-testid="section-eyebrow">
      {eyebrow}
    </p>
    <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-100 leading-tight">
      {title}
    </h2>
    {description && (
      <p className="text-sm sm:text-base text-slate-400 leading-relaxed mt-5">{description}</p>
    )}
    <div className={`h-px w-24 mt-7 bg-gradient-to-r from-amber-400/80 to-transparent ${align === "center" ? "mx-auto bg-gradient-to-r from-transparent via-amber-400/80 to-transparent" : ""}`} />
  </Reveal>
);
